'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

"use strict";
const MIN_GRAFANA_VERSION = "8.5.0";

exports.MIN_GRAFANA_VERSION = MIN_GRAFANA_VERSION;
//# sourceMappingURL=constants.cjs.map
